import { createTheme } from '@mui/material/styles';
import shippoTheme from '../styles/shippoTheme.js';
import { colors } from '../styles/colors.js';
import { elevations } from '../styles/elevations.js';

const snackbarTheme = createTheme(shippoTheme, {
    components: {
        MuiSnackbar: {
            styleOverrides: {
                root: {
                    maxWidth: '480px',
                    width: '100%',
                    [shippoTheme.breakpoints.down('sm')]: {
                        width: 'auto',
                    },
                    '& div': {
                        width: '100%',
                        '& .MuiPaper-root': {
                            padding: `${shippoTheme.spacing(1.5)} ${shippoTheme.spacing(2)}`,
                            boxShadow: elevations[3],
                        },
                        // style set within MuiAlert-root will overrides Alert component layout when consumed by Snackbar component.
                        '& .MuiAlert-root': {
                            width: 'auto',
                            display: 'flex',
                            gap: shippoTheme.spacing(1),
                            alignItems: 'center',
                            '& .MuiAlert-icon': {
                                width: 'auto',
                                height: shippoTheme.spacing(5),
                                alignItems: 'center',
                            },
                            '& .MuiAlert-message': {
                                display: 'flex',
                                justifyContent: 'space-between',
                                minHeight: shippoTheme.spacing(5),
                                height: '100%',
                                overflow: 'visible',
                                gap: shippoTheme.spacing(1),
                                '& .MuiTypography-root': {
                                    color: colors.text.default,
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    margin: 0,
                                    padding: `${shippoTheme.spacing(1)} 0`,
                                },
                                '& button': {
                                    height: shippoTheme.spacing(5),
                                    alignSelf: 'center',
                                },
                            },
                            '& .MuiAlert-action': {
                                width: 'auto',
                                height: shippoTheme.spacing(5),
                                alignItems: 'center',
                                alignSelf: 'flex-start',
                            },
                        },
                    },
                },
            },
        },
    },
});

export { snackbarTheme as default };
//# sourceMappingURL=Snackbar.theme.js.map
